(function (angular) {
    'use strict';

    angular.module('broadcast')

        .component('step3', {
            bindings: {
                forms: "="
            },
            controller: ["broadcastWizardService", "$stateParams", "profilesService", "WizardHandler", "audienceCreatorService", "NgTableParams", "$filter",
                function (broadcastWizardService, $stateParams, profilesService, WizardHandler, audienceCreatorService, NgTableParams, $filter) {

                    var ctrl = this;
                    ctrl.bws = broadcastWizardService;

                    ctrl.filter = {
                        name: undefined,
                    };


                    ctrl.tableParams = new NgTableParams(
                        {
                            page: 1,
                            count: 10,
                            // initial sort order
                            sorting: { name: "desc" },
                            filter: ctrl.filter
                        },
                        {
                            // counts: [], // hides page sizes
                            getData: function ($q, params) {

                                var orderedData = params.sorting() ?
                                    $filter('orderBy')(broadcastWizardService.audiences, params.orderBy()) : broadcastWizardService.audiences;

                                orderedData = $filter('filter')(orderedData, params.filter());

                                params.total(orderedData.length);

                                $q.resolve(orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count()));

                            }
                        });


                    /**
                     * 
                     */
                    ctrl.createAudience = function () {
                        var modalInstance = audienceCreatorService.createAudience(false);

                        return modalInstance.result
                            .then(function (audience) {
                                broadcastWizardService.audiences.push(audience);
                                ctrl.tableParams.reload();
                            });
                    }

                    /**
                     * 
                     * @param {*} audienceId 
                     */
                    ctrl.pickAudience = function (audienceId) {
                        ctrl.bws.step3Model.audienceId = audienceId;

                        ctrl.audiencePicked();
                    }

                    /**
                     * 
                     */
                    ctrl.audiencePicked = function () {

                        ctrl.pickedAudience = broadcastWizardService.audiences.find(function (a) { return a.id === ctrl.bws.step3Model.audienceId })

                        if (ctrl.pickedAudience) {
                            if (ctrl.pickedAudience.query !== undefined) {

                                var query = ctrl.pickedAudience.query;

                                profilesService.getProfilesCount($stateParams.pickedApiSpaceId, query)
                                    .then(function (result) {
                                        ctrl.numberOfProfiles = result;
                                    });

                                if (ctrl.bws.step1Model.channel === "fbMessenger" && query.indexOf("fbMessengerId") == -1) {
                                    query += "&fbMessengerId=";
                                }
                                else if (ctrl.bws.step1Model.channel == "sms" && query.indexOf("phoneNumber") == -1) {
                                    query += "&phoneNumber=";
                                }
                                else if (ctrl.bws.step1Model.channel == "appMessaging" && query.indexOf("_devices") == -1) {
                                    query += "&_devices=";
                                }
                                else if (ctrl.bws.step1Model.channel == "whatsApp" && query.indexOf("whatsApp.whatsAppId") == -1) {
                                    query += "&whatsApp.whatsAppId=";
                                }

                                profilesService.getProfilesCount($stateParams.pickedApiSpaceId, query)
                                    .then(function (result) {
                                        ctrl.numberOfPossibleProfiles = result;
                                    });
                            }

                        } else {
                            // audience has been deleted
                            ctrl.bws.step3Model.audienceId = undefined;
                        }


                    }


                    // initialise - 
                    if (ctrl.bws.step3Model.audienceId) {
                        ctrl.audiencePicked();
                    }


                    function updateAndNavigate(navFunc) {
                        ctrl.showInvalid = true;

                        if (ctrl.forms.step3Form.$valid) {
                            broadcastWizardService.updateBroadcast()
                                .then(function (succeeded) {
                                    if (succeeded) {
                                        navFunc();
                                    }
                                });
                        }
                    }

                    ctrl.prev = function () {
                        updateAndNavigate(WizardHandler.wizard("broadcastWizard").previous);
                    }

                    ctrl.next = function () {
                        updateAndNavigate(WizardHandler.wizard("broadcastWizard").next);
                    }


                }],
            templateUrl: 'components/toolkit/broadcast/templates/step3.html'
        })

})(window.angular);